import { fromJS } from 'immutable';
import { NODE_WIDTH } from './seriesOptions';
const COLUMN_HEADER_VERTICAL_OFFSET = 20;
const generateLabelPositions = (nodeXPositions, plotWidth, plotLeft) => {
  const numColumns = nodeXPositions.length;
  const standardLabelWidth = (plotWidth - NODE_WIDTH) / (numColumns - 1);
  return nodeXPositions.map((nodeXPos, columnIdx) => {
    const first = columnIdx === 0;
    const last = columnIdx === numColumns - 1;
    return {
      xPos: nodeXPos + plotLeft + (first ? 0 : last ? NODE_WIDTH : NODE_WIDTH / 2),
      width: first || last ? (standardLabelWidth + NODE_WIDTH) / 2 : standardLabelWidth
    };
  });
};
export const getChartOptions = columnHeaders => fromJS({
  chart: {
    spacingBottom: 50,
    height: '25%',
    events: {
      load() {
        const series = this.series[0];
        series.points.forEach(point => {
          if (point.weight === 0) {
            point.update({
              weight: 0.1,
              color: 'transparent'
            });
          }
          if (!series.customHeaders) {
            series.customHeaders = columnHeaders.map(columnHeaderLabel => ({
              label: columnHeaderLabel,
              textElement: undefined
            }));
          }
        });
      },
      render() {
        const series = this.series[0];
        const columns = series.nodeColumns;
        const nodeXPositions = columns.map(column => column[0].nodeX);
        const positionInfo = generateLabelPositions(nodeXPositions, this.plotWidth, this.plotLeft);
        if (series.customHeaders) {
          positionInfo.forEach(({
            xPos,
            width
          }, index) => {
            if (!isNaN(xPos)) {
              const maybeTextElement = series.customHeaders[index].textElement;
              if (maybeTextElement) {
                maybeTextElement.attr({
                  x: xPos,
                  y: this.chartHeight - COLUMN_HEADER_VERTICAL_OFFSET
                }).css({
                  width
                });
              } else {
                series.customHeaders[index].textElement = this.renderer.text(series.customHeaders[index].label).attr({
                  x: xPos,
                  y: this.chartHeight - COLUMN_HEADER_VERTICAL_OFFSET,
                  'text-anchor': index === 0 ? 'start' : index === positionInfo.length - 1 ? 'end' : 'middle'
                }).css({
                  width,
                  textOverflow: 'ellipsis'
                }).add();
              }
            }
          });
        }
      }
    }
  }
});
export const __TESTABLE__ = {
  generateLabelPositions
};